import React, { useState, useCallback, useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import styles from './FileInput.module.scss'
import FormattedMessage from '../../helpers/FormattedMessage'
import { Prompt } from '../Prompt'
import iconClose from '../../assets/icons/icn-close.svg'

interface IProps {
  design: string
  union?: boolean
  valueFiles: any
  onChange: (files: any) => void
  onRemove?: () => void
}

const formats = ['.pdf', '.ai']

export const FileInput = ({
  design,
  union = false,
  valueFiles,
  onChange,
  onRemove,
}: IProps) => {
  const [removePrompt, setRemovePrompt] = useState(false)
  const [removeFileName, setRemoveFileName] = useState('')
  const [files, setFiles] = useState(valueFiles)
  const [newFiles, setNewFiles] = useState<any>([])
  const [onOver, setOnOver] = useState(false)
  const [twoFilesError, setTwoFilesError] = useState(false)
  const [oneFileError, setOneFileError] = useState(false)

  const checkMultiFileDesign = useCallback((design: string) => {
    console.log(design, union)
    return (design === 'design4' && !union)
  }, [])

  useEffect(() => {
    const checkFiles = () => {
      if (newFiles.length === 1 || valueFiles.length === 1 || newFiles.length > 2 || valueFiles.length > 2) {
        setTwoFilesError(true)
      } else {
        setTwoFilesError(false)
      }
    }
    if (newFiles.length === 0 && valueFiles.length === 0) {
      !checkMultiFileDesign(design)
        && setOneFileError(true)
        && setTwoFilesError(false)

      checkMultiFileDesign(design)
        && setTwoFilesError(true)
        && setOneFileError(false)
    } else if (!checkMultiFileDesign(design) && (newFiles.length !== 1 && valueFiles.length !== 1)) {
      setOneFileError(true)
    } else if (checkMultiFileDesign(design)) {
      checkFiles()
    } else {
      setOneFileError(false)
      setTwoFilesError(false)
    }
  }, [newFiles, valueFiles, checkMultiFileDesign, design])

  const onDrop = useCallback((acceptedFiles) => {
    setOnOver(false)
    setTwoFilesError(false)
    const newArr = [...newFiles, ...acceptedFiles]
    setNewFiles(newArr)
    onChange(newArr)
  }, [newFiles, onChange])

  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
    accept: formats.join(','),
    onDragEnter: () => {
      setOnOver(true)
    },
    onDragLeave: () => {
      setOnOver(false)
    },
  })

  const removeFileHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, name: string) => {
    e.stopPropagation()
    setRemoveFileName(name)
    setRemovePrompt(true)
  }

  const removeFile = () => {
    const newArr = [...(newFiles.length ? newFiles : files)].filter((file: any) => file.name !== removeFileName)
    setFiles(newArr)
    setNewFiles(newArr)
    onChange(newArr)
    newFiles.length === 0 && onRemove && onRemove()
    setRemoveFileName('')
    setRemovePrompt(false)
  }

  const closePrompt = () => {
    setRemovePrompt(false)
  }

  return (
    <>
      <div className={`${styles.Wrapper} ${onOver && styles.Over} ${(oneFileError || twoFilesError) && styles.Error}`}>
        <div {...getRootProps()}>
          <div className={styles.TopSection}>
            {files.length || newFiles.length ?
              <div className={styles.FilesWrapper}>
                {(newFiles.length ? newFiles : files).map((file: any, index: number) => (
                  <div className={styles.FileBox} onClick={(e) => { removeFileHandler(e, file.name) }} key={index}>
                    <span>{file.name}</span>
                    <img className={styles.RemoveBtn} src={iconClose} alt={'close'}/>
                  </div>
                ))}
              </div>
              :
              <div>
                <FormattedMessage id="Drag&Drop.title"/>
              </div>
            }
          </div>
          <div className={styles.Button}>
            <span><FormattedMessage id="Drag&Drop.button" /></span>
          </div>
          <div className={styles.Formats}>
            <FormattedMessage
              id="Drag&Drop.formats"
              values={{ formats: formats.map(item => item.split('.')[1].toUpperCase()).join(' ') }}
            />
          </div>
          <input {...getInputProps()} />
        </div>
        {removePrompt &&
          <Prompt
              title="RemovePrompt.title"
              componentText={
                <FormattedMessage
                  id="RemovePrompt.text"
                  values={{ file: removeFileName }}
                />
              }
              cancel={closePrompt}
              submit={removeFile}
              submitText="remove"
              warning
          />
        }
      </div>
      {(twoFilesError || oneFileError) &&
        <div className={styles.ErrorText}>
          <FormattedMessage id={twoFilesError ?
            'Drag&Drop.error.twoFiles'
            : 'Drag&Drop.error.oneFiles'} />
        </div>
      }
    </>
  )
}
